import util from '../util'

let controller = 'SenhaEletronica'
export default Object.assign({}, {
  BuscarSenhas: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  AprovarReprovarSolicitacao: function (dto) {
    return util.Axios.Post(controller + '/AprovarReprovar', dto)
  },
  DesbloquearOperador: function (dto) {
    return util.Axios.Post(controller + '/Desbloquear', dto)
  },
  ComboOperadoresFrontEndSenhaBloqueada: function (dto) {
    return util.Axios.GetAll(controller + '/ComboOperadoresFrontEndSenhaBloqueada', dto )
  }
})